document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.rezdy-calendar-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    const handle = wrapper.dataset.productHandle || 'unknown-product';
    const alias = wrapper.dataset.rezdyAlias;
    const calendarId = wrapper.dataset.rezdyCalendarId;
    const rezdyProductCode = wrapper.dataset.rezdyProductCode;

    if (!alias) {
      console.warn('Missing Rezdy alias for:', handle);
      renderRezdyError(wrapper, `Missing Rezdy alias for ${handle}`);
      return;
    }

    // For current calendar widget view:
    if (!calendarId) {
      console.warn('Missing Rezdy calendar ID for:', handle);
      renderRezdyError(wrapper, `Missing Rezdy calendar ID for ${handle}`);
      return;
    }

    // Available for future non-calendar widgets/views:
    // rezdyProductCode can be used later for bookingWidget or other embeds.
    if (!rezdyProductCode) {
      console.warn('Missing Rezdy product code for:', handle);
    }

    loadRezdyPlugin(alias);

    const iframeSrc = buildRezdyCalendarUrl(alias, calendarId);
    renderRezdyCalendar(wrapper, iframeSrc);
  });
});

const loadedAliases = new Set();

function loadRezdyPlugin(alias) {
  if (loadedAliases.has(alias)) return;

  const script = document.createElement('script');
  script.src = `https://${alias}.rezdy.com/pluginJs`;
  script.defer = true;
  document.head.appendChild(script);

  loadedAliases.add(alias);
}

function buildRezdyCalendarUrl(alias, calendarId) {
  return `https://${alias}.rezdy.com/calendarWidget/${calendarId}?iframe=true`;
}

function renderRezdyCalendar(wrapper, iframeSrc) {
  wrapper.innerHTML = `
    <div class="rezdy-calendar-embed">
      <iframe
        seamless
        width="100%"
        height="1000"
        frameborder="0"
        class="rezdy"
        src="${iframeSrc}">
      </iframe>
    </div>
  `;
}

function renderRezdyError(wrapper, message) {
  wrapper.innerHTML = `
    <div class="rezdy-calendar-error" style="padding: 12px; border: 1px solid #ddd; border-radius: 8px;">
      ${message}
    </div>
  `;
}